import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';

import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';

import ImageComponent from 'shared/ImageComponent';
import { handleRedirection } from 'utils/utils';

function SelectedAttendees(props) {
  const { selectedAttendees, control, history, watch, updateReminder, setValue } = props;
  const contacts = watch('contacts') || selectedAttendees;
  const sendReminderValues = contacts?.map((_, id) => watch(`contacts.${id}.send_reminder`, false));

  const isReminderRequired = sendReminderValues?.some((value) => value === true);

  useEffect(() => {
    updateReminder('contacts', isReminderRequired);
  }, [isReminderRequired, contacts]);

  const handleSendReminderChange = (id, value) => {
    const updatedContacts = [...contacts];
    updatedContacts[id].send_reminder = value;
    setValue('contacts', updatedContacts);
  };

  return (
    <div className="d-flex align-items-center py-2">
      <div className="col-12">
        <div className="">
          <table className="table attendees-table">
            <thead>
              <tr>
                <th className="attendee-names">Contacts</th>
                <th className="text-center">
                  <label className="text-muted">Required</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Optional</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Send Reminder</label>
                </th>
              </tr>
            </thead>
            {selectedAttendees.map((item, id) => {
              return (
                <tbody key={id}>
                  <td className="attendee-names">
                    <div
                      className="d-flex redirection-link-no-text-transform"
                      onClick={() => {
                        let url = `/contacts`;
                        if (item?.contact_id) url = `/contacts/${item?.contact_id}`;
                        handleRedirection(history, url);
                      }}
                    >
                      <ImageComponent filePath={item?.profile_image} fileName={item.name} fileSize="small.jpg" />
                      <div className="mx-2 align-items-center d-flex">{item.name}</div>
                    </div>
                  </td>

                  <Controller
                    name={`contacts.${id}.is_attendance_required`}
                    control={control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <td className="text-center">
                          <div>
                            <RadioButton
                              inputId="required"
                              name={field.name}
                              value="required"
                              checked={field.value === 'required'}
                              onChange={(e) => field.onChange(e.value)}
                            />
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="p-field-radiobutton">
                            <RadioButton
                              inputId="optional"
                              name="gender"
                              value="optional"
                              checked={field.value === 'optional'}
                              onChange={(e) => field.onChange(e.value)}
                            />
                          </div>
                        </td>
                      </>
                    )}
                  />

                  <Controller
                    name={`contacts.${id}.send_reminder`}
                    control={control}
                    render={({ field }) => (
                      <td className="text-center">
                        <InputSwitch
                          id={field.name}
                          value={field.value}
                          checked={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            handleSendReminderChange(id, e.value);
                          }}
                          placeholder="Meeting URL"
                        />
                      </td>
                    )}
                  />
                </tbody>
              );
            })}
          </table>
        </div>
      </div>
    </div>
  );
}

export default SelectedAttendees;
